<script>
    import ImageTile from "./ImageTile.svelte";
    import ProductInformation from "./ProductInformation.svelte";
    import EnergyEfficiency from "./EnergyEfficiency.svelte";
    import clickTracker from "../tracking/clickTracker.js";
    import DiscountTag from "./DiscountTag.svelte";
    import { getContext } from "svelte";
    import { key as cinemaTileDimensionCtxKey } from "../context/cinemaTileDimension.js";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        recommendation,
        lazyLoad,
        featuresState = {},
        cinemaTracking = null,
        featureIndex = undefined,
        cinemaIndex = undefined,
        cinemaMeta = null,
        additionalClickTracking = null,
        hasElevationLevel = false,
        additionalNextPiTrackingLabels = null,
        additionalTrackingLabels = null,
        personalisedUser = false,
    } = $props();

    const tileDimensions = getContext(cinemaTileDimensionCtxKey);

    const {
        brandName,
        image,
        _embedded: { "o:variation": variation },
        formattedPrice: pricing,
        tracking,
    } = recommendation;

    const showEnergyEfficiency = Array.isArray(variation.energyEfficiencyClasses) && variation.energyEfficiencyClasses.length >= 1;
    const discountValue = featuresState.ENABLE_DISCOUNT_TAG_IN_RECOMMENDATION ? variation.discountValue : null;

    const baseDetailViewUrl = variation._links["o:base-detail-view-url"]?.href;
    const variationDetailViewUrl = variation._links["o:variation-detail-view-url"]?.href;
    const conditionalBaseDetailViewUrl = !baseDetailViewUrl ? {} : { href: baseDetailViewUrl };

    const clickHandler = () => {
        clickTracker(
            cinemaTracking,
            tracking,
            featureIndex,
            cinemaIndex,
            additionalClickTracking,
            recommendation.additionalClickTracking,
            cinemaMeta,
            recommendation.meta,
            additionalTrackingLabels,
            additionalNextPiTrackingLabels
        );
    };

    const getDataTracking = () => {
        const promoSource = recommendation.tracking?.labels?.promo_Source;
        const promoTypeSuffix = recommendation.tracking?.name?.split("-")[0];

        if (!promoSource || !promoTypeSuffix) {
            return undefined;
        }

        return '{"promo_Source":"' + promoSource + '","promo_Type":"' + `promo_${promoTypeSuffix}` + '"}';
    };
</script>

<div
    style:min-width={`${tileDimensions.minimumWidth}px`}
    data-tracking={getDataTracking()}
    data-tracking-feature-id={tracking?.id}
    data-qa="slidingCinemaPromotion"
    class="reco_card_cinema__tile"
>
    <oc-card-v2 style:min-width={`${tileDimensions.minimumWidth}px`}>
        <div class="reco_card_cinema__tile_content {hasElevationLevel ? 'reco_card_cinema__tile_content_stacked' : ''}">
            <oc-link-v2 base64-href={btoa(variationDetailViewUrl)} data-testid="reco-card">
                <a class="reco_card_cinema__adslink" {...conditionalBaseDetailViewUrl} onclick={clickHandler}>
                    <div class="reco_cinema__spacer">
                        <ImageTile
                            variationId={variation.id}
                            {image}
                            {lazyLoad}
                            {featuresState}
                            {personalisedUser}
                            fromCardRecommendation={true}
                        />
                    </div>
                    <div class="reco_card_cinema__product-information">
                        <ProductInformation {brandName} {variation} {pricing} showTopInfo={false} />
                    </div>
                </a>
            </oc-link-v2>

            <div class="reco_card_cinema__discount_tag">
                <DiscountTag {discountValue} />
            </div>
            {#if showEnergyEfficiency}
                <div class="reco_card_cinema__energy-efficiency">
                    <EnergyEfficiency energyEfficiencyClasses={variation.energyEfficiencyClasses} isBrand={true} />
                </div>
            {/if}
        </div>
    </oc-card-v2>
</div>

<style lang="scss">
    .reco_card_cinema {
        &__tile {
            display: grid;
            margin: 0 8px 0 0;
            white-space: normal;
            height: 100%;

            &:last-child {
                margin-right: 0;
            }

            &_content {
                height: 100%;
                padding: 4px;
                flex-grow: 1;
                background-color: white;

                &_stacked {
                    background-color: var(--background-color, var(--oc-semantic-color-stacked-background, #f0f0f0));
                    filter: var(--oc-semantic-shadow-stacked, unset);
                }
            }
        }

        &__product-information {
            padding: 0 4px;
        }

        &__energy-efficiency {
            padding: 4px 0 8px 4px;
        }

        &__adslink {
            color: black;
            text-decoration: none;
            overflow-y: auto;
        }

        &__adslink:hover {
            text-decoration: black underline;
        }

        &__adslink:hover :global(.reco_cinema__price-per-unit) {
            text-decoration: grey underline;
        }

        &__discount_tag {
            padding: 0 4px;
        }
    }

    .reco_cinema__spacer {
        border-radius: 12px;
        background: white;
    }
</style>
